import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AddEventPageSlice } from "../../../redux/features/EventPageManagementSlice";
import Editor from "../../../common/Editor/Editor";
import ReviewSection from "../ReviewSection";

const AddEventPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [form, setForm] = useState({
    title: "",
    description: "",
    h1Title: "",
    pageDescription: "",
    content: "",
    status: "active",
  });
  const [reviews, setReviews] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    if (!form.title || !form.description || !form.h1Title || !form.pageDescription) {
      alert("Title, Description, H1 Title and Page Description are required");
      return;
    }

    dispatch(AddEventPageSlice({ ...form, reviews }))
      .then((res) => {
        if (res?.payload?.success) {
          navigate("/EventPageManagement");
        } else {
          alert(res?.payload?.message || "Failed to add Event Page");
        }
      })
      .catch((err) => {
        console.error(err);
        alert("Something went wrong!");
      });
  };

  return (
    <div className="Small-Wrapper mt-4">
      {/* Title */}
      <div className="form-group">
        <label>Title</label>
        <input
          type="text"
          name="title"
          className="form-control"
          value={form.title}
          onChange={handleChange}
        />
      </div>

      {/* Description */}
      <div className="form-group">
        <label>Description</label>
        <textarea
          name="description"
          className="form-control"
          value={form.description}
          onChange={handleChange}
        />
      </div>

      {/* H1 Title */}
      <div className="form-group">
        <label>H1 Title</label>
        <input
          type="text"
          name="h1Title"
          className="form-control"
          value={form.h1Title}
          onChange={handleChange}
        />
      </div>

      {/* Page Description */}
      <div className="form-group">
        <label>Page Description</label>
        <textarea
          name="pageDescription"
          className="form-control"
          value={form.pageDescription}
          onChange={handleChange}
        />
      </div>

      {/* Status */}
      <div className="form-group">
        <label>Status</label>
        <select
          name="status"
          className="form-control"
          value={form.status}
          onChange={handleChange}
        >
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
      </div>

      {/* Content */}
      <div className="form-group">
        <label>Content</label>
        <Editor
          setContentState={setForm}
          type="content"
          content={form.content}
          form={form}
        />
      </div>

      {/* Reviews */}
      <ReviewSection reviews={reviews} setReviews={setReviews} />

      <button className="Button mt-3" onClick={handleSubmit}>
        Add
      </button>
    </div>
  );
};

export default AddEventPage;
